"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "column-chart"
  }, [_c("p", {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v(" Inquiries ")]), _c("span", {
    staticClass: "info"
  }, [_vm._v("Last 7 Days")]), _vm.chartData.length > 1 ? _c("GChart", {
    staticStyle: {
      "font-family": "'Times New Roman', Times, serif"
    },
    attrs: {
      data: _vm.chartData,
      options: _vm.chartOptions,
      type: "ColumnChart"
    }
  }) : _c("span", {
    staticClass: "no-data"
  }, [_vm._v("No Data Available.")])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;